<script>
    import Icon from "./Icon.svelte";
    export let site;
    export let searchTerm;
    export let searchSuffixes = [];

    let siteConfig = {
        google: {
            url: "https://www.google.com/search",
            icon: "google",
            queryString: "q",
        },
        youtube: {
            url: "https://www.youtube.com/results",
            icon: "youtube",
            queryString: "search_query",
        },
    };

    let searchboxInput;
    $: searchboxInput = searchTerm;
</script>

<form action={siteConfig[site].url} method="get" target="_blank" class="external_searchbar">

    <div class="icon icon-site"><Icon icon={siteConfig[site].icon} /></div>

    <input type="search" name={siteConfig[site].queryString} bind:value={searchboxInput} />

    {#each searchSuffixes as searhSuffix}
        <a
            class="search-button"
            target="_blank"
            href={siteConfig[site].url + "?" + siteConfig[site].queryString + "=" + searchboxInput + "+" + searhSuffix}
        >
            {searhSuffix}
        </a>
        <div class="horizontal-divider"></div>
    {/each}
    <button type="submit" class="search-button"><div class="icon"><Icon icon="search" /></div></button>

</form>

<style>
    :root {
        --searchbar-height: 2.5rem;
    }

    .external_searchbar {
        display: flex;
        align-items: center;
        width: 100%;
        border: 1px solid #cccccc;
        border-radius: calc(var(--searchbar-height)/2);
        background-color: white;
    }

    .icon {
        flex: 0 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1.25rem;
        height: var(--searchbar-height);
    }

    .icon-site {
        padding-left: 1rem;
    }

    input {
        flex: 1 1 auto;
        width: 1rem;
        height: var(--searchbar-height);
        padding: 0 0.75rem;
        outline: none;
        border: none;
        font-family: inherit;
        font-size: inherit;
    }

    .horizontal-divider {
        width: 0.0625rem;
        height: 1rem;
        background-color: #eeeeee;
    }

    .search-button {
        padding: 0 0.5rem;
        height: var(--searchbar-height);
        color: inherit;
        font: inherit;
        cursor: pointer;
    }

    a.search-button {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        text-decoration: inherit;
        font-size: smaller;
    }

    button.search-button {
        padding-right: 1rem;
        border: none;
        outline: inherit;
        border-top-right-radius: calc(var(--searchbar-height)/2);
        border-bottom-right-radius: calc(var(--searchbar-height)/2);
        background: none;
    }

    .search-button:hover {
        background-color: #eeeeee;
    }
</style>
